export const NOTIFICATION_DOMAIN_EVENT_NAMES = [
  "job.created",
  "job.applied",
  "job.accepted",
  "job.withdrawn",
  "job.replaced",
  "job.visit-started",
  "job.visit-done",
  "job.report-submitted",
  "job.paid",
  "job.deleted",
  "branch.created",
  "branch.updated",
  "branch.deleted",
  "branch.restored",
  "branch.rate-added",
  "branch.rate-updated",
  "branch.rate-deleted",
  "branch.google-rate-received",
  "shopper.registered",
  "shopper.verified",
  "wallet.transaction-created",
  "wallet.shopper-paid",
  "wallet.transaction-updated",
  "wallet.bank-transfer-submitted",
  "wallet.invoice-sent",
  "company.created",
  "manager.registered",
  "media.created",
  "consultation.submitted",
  "contact-us.submitted",
  "cron-job.state-changed",
  "evaluation.answer-submitted",
] as const;

export type EventName = (typeof NOTIFICATION_DOMAIN_EVENT_NAMES)[number];

export const BROADCAST_MESSAGE_WRAPPER_TYPE = "broadcast.message";

export type BroadcastEnvelope<T = unknown> = {
  id: string;
  type?: string;
  occurred_at?: string;
  created_at?: string;
  payload?: T;
  data?: {
    event?: string;
    payload?: T;
  };
};

export type NotificationItem = {
  id: string;
  eventName: EventName;
  occurredAt: string;
  payload: Record<string, unknown>;
  isRead: boolean;
};

export const isNotificationDomainEvent = (value: string): value is EventName => {
  return NOTIFICATION_DOMAIN_EVENT_NAMES.includes(value as EventName);
};
